import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { optimiseDeleteApi, optimiseEditApi, optimiseGetApi, optimisePostApi, optimiseUpdateApi } from '../optimiseCode';

@Injectable({
  providedIn: 'root'
})
export class MyChapterService {

  public url = "https://englearn.sparkleweb.co.in/api/chapter";

  constructor(private _http: HttpClient) { }

  getChapterList(id: any,pageSize:number,pageIndex:number,search:any) {
    //return this._http.get(this.url).pipe(catchError(this.errorHandler));
    // return this._http.get(this.url + "/getchapterlistbycoursetopicid?CourseTopicId=" + id + "&devicetype=website").pipe(catchError(this.errorHandler));
    return optimiseGetApi(`${this.url+"/getchapterlistbycoursetopicid?PageIndex="}${pageIndex}&PageSize=${pageSize}&Search=${search}&CourseTopicId=${id}`).pipe(catchError(this.errorHandler));
    // return optimiseGetApi(`${this.url+"/getchapterlistbycoursetopicid?PageIndex="}${pageIndex}&PageSize=${pageSize}&CourseTopicId=${id}`);

  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || "Unknown Server Error");
  }

  postChapterList(data: any) {
    //data.append('ImageFile', file);
    // return this._http.post(this.url + "/addchapter", data);
    return optimisePostApi(this.url+"/addchapter", data);
  }

  deleteChapterList(id: any) {
    // return this._http.delete(`${this.url + "/deletechapter?id="}${id}`);
    return optimiseDeleteApi(`${this.url + "/deletechapter?id="}${id}`);
  }

  getList(id: any) {
    // return this._http.get(`${this.url + "/getchapterbyid?id="}${id}`+"&devicetype=website&email=");
    return optimiseEditApi(`${this.url+"/getchapterbyid?id="}${id}`+"&devicetype=website&email=");
  }

  updateChapterList(data: any) {
    // return this._http.put(`${this.url + "/updatechapter"}`, data);
    return optimiseUpdateApi(`${this.url+"/updatechapter"}`, data);
  }

}
